<template>
  <q-page style="height: 100vh" class="q-pa-sm">
    <div class="row">
      <div class="col-12">
        <q-card style="height: calc(100vh - 20px)">
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Waves Results
              </div>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
              >
              </q-btn>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <q-tabs v-model="tab" class="text-black">
              <q-tab name="pointsTable" label="Points Table" />
              <q-tab name="medalsTable" label="Medals Table" />
              <q-tab name="eventBrackets" label="Results" />
            </q-tabs>
          </q-card-section>
          <q-card-section v-if="tab == 'pointsTable'">
            <div v-if="overallPoints">
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 190px) !important"
                >
                  <datatable
                    :filter="overallPointsFilter.search"
                    :flat="true"
                    :data="overallPoints"
                    :columns="overAllPointsColumn"
                    @rowDoubleClick="handleDoubleClickOverallPoints"
                  >
                    <template slot="body-cell-rank" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.rowIndex + 1 }}</b>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-association_abbr"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <q-img
                          v-if="data.props.row.capUrl"
                          :src="data.props.row.capUrl"
                          style="width: 40px"
                          contain
                        >
                        </q-img>
                        {{ data.props.row.association_abbr }}
                      </q-td>
                    </template>
                    <template slot="body-cell-points" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.row.points }}</b>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="tab == 'medalsTable'">
            <div v-if="overallMedals">
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 190px) !important"
                >
                  <datatable
                    :filter="overallMedalsFilter.search"
                    :flat="true"
                    :data="overallMedals"
                    :columns="overAllMedalsColumn"
                    @rowDoubleClick="handleDoubleClickOverallMedals"
                  >
                    <template slot="body-cell-rank" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.rowIndex + 1 }}</b>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-association_abbr"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <q-img
                          v-if="data.props.row.capUrl"
                          :src="data.props.row.capUrl"
                          style="width: 40px"
                          contain
                        >
                        </q-img>
                        {{ data.props.row.association_abbr }}
                      </q-td>
                    </template>
                    <template slot="body-cell-medals" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.row.medals }}</b>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="tab == 'eventBrackets'">
            <div v-if="!selectedEvent">
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 190px) !important"
                >
                  <datatable
                    :filter="eventsFilter.search"
                    :flat="true"
                    :data="events"
                    :columns="eventColumns"
                    @rowDoubleClick="handleDoubleClickEvents"
                  >
                    <template
                      slot="body-cell-eventProgression"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <b>
                          {{
                            data.props.row.currentStep == 0
                              ? "Registration"
                              : data.props.row.currentStep == 1
                              ? "Drawing Lanes"
                              : data.props.row.currentStep == 2
                              ? "Event In Progress"
                              : "Finished"
                          }}
                        </b>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
            <q-scroll-area
              v-if="selectedEvent"
              style="height: calc(100vh - 190px) !important; width: 100%"
            >
              <div style="display: inline-block" class="text-h6">
                <q-btn
                  icon="mdi-arrow-left"
                  flat
                  @click="selectedEvent = null"
                ></q-btn>
                {{ selectedEvent.event_name }}
              </div>
              <div class="container">
                <div class="tournament-bracket tournament-bracket--rounded">
                  <!-- Rounds -->
                  <div
                    v-for="(round, roundIndex) in brackets"
                    :key="`round_${roundIndex}`"
                    class="tournament-bracket__round"
                    :style="`${
                      $q.screen.gt.sm
                        ? 'max-width: 400px; min-width: 400px'
                        : ''
                    }`"
                  >
                    <h3
                      class="tournament-bracket__round-title text-black"
                      style="font-weight: bold"
                    >
                      {{ round.round_name.replace(/[0-9]/g, "") }}
                    </h3>
                    <ul
                      class="tournament-bracket__list"
                      :class="{
                        noMoreEvents: roundIndex == brackets.length - 1,
                      }"
                    >
                      <li
                        v-for="(race, raceIndex) in round.races"
                        :key="`race_${raceIndex}`"
                        class="tournament-bracket__item"
                        :class="{
                          notBracket: !round.is_final,
                          bracketStart:
                            brackets[roundIndex - 1] &&
                            !brackets[roundIndex - 1].is_final,
                          singlePassthrough:
                            brackets[roundIndex + 1] &&
                            brackets[roundIndex + 1].races.length ==
                              round.races.length,
                        }"
                      >
                        <div
                          class="tournament-bracket__match"
                          style="background: #f7fafc"
                          tabindex="0"
                        >
                          <table class="tournament-bracket__table">
                            <caption
                              class="tournament-bracket__caption text-black"
                            >
                              {{
                                round.round_name.replace(/[0-9]/g, "")
                              }}
                              {{
                                race.race_index + 1
                              }}
                            </caption>
                            <thead>
                              <tr>
                                <th width="50px">Pl.</th>
                                <th>{{ isTeamEvent ? "Team" : "Athlete" }}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody class="tournament-bracket__content">
                              <tr
                                v-for="(lane, laneIndex) in race.lanes"
                                :key="`lane_${laneIndex}`"
                                class="tournament-bracket__team"
                              >
                                <td class="tournament-bracket__score">
                                  <span
                                    class="tournament-bracket__number"
                                    style="font-size: 16px; font-weight: bold"
                                  >
                                    {{
                                      lane.placing
                                        ? ordinal_suffix_of(lane.placing)
                                        : "TBA"
                                    }}
                                  </span>
                                </td>

                                <td class="tournament-bracket__country">
                                  <div class="row">
                                    <q-img
                                      :src="lane.capUrl"
                                      class="clubCap"
                                      contain
                                    ></q-img>
                                    <div class="col q-ml-sm">
                                      <b v-if="!lane.team_name">
                                        {{ lane.firstName }} {{ lane.lastName }}
                                      </b>
                                      <b v-else>{{ lane.team_name }}</b> <br />
                                      <span
                                        class="tournament-bracket__number"
                                        style="font-size: 10px"
                                      >
                                        {{ lane.association_abbr }}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {{ lane.master_time }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </q-scroll-area>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <!-- <div class="row bg-black">
      <div class="col-12">
        <div class="container">
          <div class="tournament-bracket tournament-bracket--rounded">
            <div
              class="
                tournament-bracket__round
                tournament-bracket__round--quarterfinals
              "
            >
              <h3 class="tournament-bracket__round-title">Quarterfinals</h3>
              <ul class="tournament-bracket__list">
                <li class="tournament-bracket__item">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-18">18 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Rank</th>
                          <th>Athlete</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Canada"
                              >CAN</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-ca
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">4</span>
                          </td>
                        </tr>
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Kazakhstan"
                              >KAZ</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-kz
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">1</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>

                <li class="tournament-bracket__item">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-18">18 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Country</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Czech Republic"
                              >CZE</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-cz
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">4</span>
                          </td>
                        </tr>
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Unitede states of America"
                              >USA</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-us
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">1</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li class="tournament-bracket__item">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-18">18 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Country</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Finland"
                              >FIN</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-fi
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">2</span>
                          </td>
                        </tr>
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Sweden"
                              >SVE</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-se
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">1</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>

                <li class="tournament-bracket__item">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-18">18 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Country</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Russia"
                              >RUS</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-ru
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">4</span>
                          </td>
                        </tr>
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Belarus"
                              >BEL</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-by
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">1</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="
                tournament-bracket__round tournament-bracket__round--semifinals
              "
            >
              <h3 class="tournament-bracket__round-title">Semifinals</h3>
              <ul class="tournament-bracket__list">
                <li class="tournament-bracket__item">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-20">20 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Country</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Canada"
                              >CAN</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-ca
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">1</span>
                          </td>
                        </tr>
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Czech Republic"
                              >CZE</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-cz
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">2</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>

                <li class="tournament-bracket__item">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-20">20 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Country</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Finland"
                              >FIN</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-fi
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">4</span>
                          </td>
                        </tr>
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Russia"
                              >RUS</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-ru
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">7</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
              </ul>
            </div>
            <div class="tournament-bracket__round">
              <h3 class="tournament-bracket__round-title">Bronze medal game</h3>
              <ul class="tournament-bracket__list">
                <li class="tournament-bracket__item singlePassthrough">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-21">21 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Country</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Finland"
                              >FIN</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-fi
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">3</span>
                            <span
                              class="
                                tournament-bracket__medal
                                tournament-bracket__medal--bronze
                                fa fa-trophy
                              "
                              aria-label="Bronze medal"
                            ></span>
                          </td>
                        </tr>
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Canada"
                              >CAN</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-ca
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">2</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="tournament-bracket__round tournament-bracket__round--gold"
            >
              <h3 class="tournament-bracket__round-title">Gold medal game</h3>
              <ul class="tournament-bracket__list">
                <li class="tournament-bracket__item finalBracket">
                  <div class="tournament-bracket__match" tabindex="0">
                    <table class="tournament-bracket__table">
                      <caption class="tournament-bracket__caption">
                        <time datetime="1998-02-22">22 February 1998</time>
                      </caption>
                      <thead>
                        <tr>
                          <th>Country</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody class="tournament-bracket__content">
                        <tr
                          class="
                            tournament-bracket__team
                            tournament-bracket__team--winner
                          "
                        >
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Czech Republic"
                              >CZE</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-cz
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">1</span>
                            <span
                              class="
                                tournament-bracket__medal
                                tournament-bracket__medal--gold
                                fa fa-trophy
                              "
                              aria-label="Gold medal"
                            ></span>
                          </td>
                        </tr>
                        <tr class="tournament-bracket__team">
                          <td class="tournament-bracket__country">
                            <abbr
                              class="tournament-bracket__code"
                              title="Russia"
                              >RUS</abbr
                            >
                            <span
                              class="
                                tournament-bracket__flag
                                flag-icon flag-icon-ru
                              "
                              aria-label="Flag"
                            ></span>
                          </td>
                          <td class="tournament-bracket__score">
                            <span class="tournament-bracket__number">0</span>
                            <span
                              class="
                                tournament-bracket__medal
                                tournament-bracket__medal--silver
                                fa fa-trophy
                              "
                              aria-label="Silver medal"
                            ></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";

  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: { datatable },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        overallPoints: "liveResults/overallPoints",
        overallPointsLoading: "liveResults/overallPointsLoading",
        overallMedals: "liveResults/overallMedals",
        overallMedalsLoading: "liveResults/overallMedalsLoading",
        brackets: "liveResults/currentEventBrackets",
        bracketsLoading: "liveResults/currentEventBracketsLoading",
        events: "events/listForWaves",
        eventsLoading: "events/listForWavesLoading",
      }),
    },
    data: () => ({
      isTeamEvent: null,
      tab: "pointsTable",
      selectedEvent: null,
      eventsFilter: {
        search: "",
      },
      eventColumns: [
        {
          name: "event_no",
          label: "#",
          align: "left",
          field: "event_no",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "eventName",
          label: "Event",
          align: "left",
          field: "event_name",
          style:
            "min-width: 150px;max-width: 150px;width: 150px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "entries",
          label: "Entries",
          align: "left",
          field: "entries",
          style:
            "min-width: 100px;max-width: 100px;width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          format: (val, row) =>
            row.individualEntries > 0
              ? `${row.individualEntries} athletes`
              : row.teamEntries > 0
              ? `${row.teamEntries} teams`
              : "",
          sortable: true,
        },
        {
          name: "eventProgression",
          label: "Event Progression",
          align: "left",
          style:
            "min-width: 50px;max-width: 50px;width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
      ],

      // OverALl Points
      overallPointsFilter: {
        search: "",
      },
      overAllPointsColumn: [
        {
          name: "rank",
          label: "Rank",
          align: "left",
          field: "rank",
          style:
            "min-width: 40px;max-width: 40px;width: 40px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "association_abbr",
          label: "Club",
          align: "left",
          field: "association_abbr",
          style:
            "min-width: 200px;max-width: 200px;width: 200px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "points",
          label: "Points",
          align: "left",
          field: "points",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "1",
          label: "1st",
          align: "left",
          field: "1",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "2",
          label: "2nd",
          align: "left",
          field: "2",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "3",
          label: "3rd",
          align: "left",
          field: "3",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "4",
          label: "4th",
          align: "left",
          field: "4",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "5",
          label: "5th",
          align: "left",
          field: "5",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "6",
          label: "6th",
          align: "left",
          field: "6",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
      ],

      // OverALl Medals
      overallMedalsFilter: {
        search: "",
      },
      overAllMedalsColumn: [
        {
          name: "rank",
          label: "Rank",
          align: "left",
          field: "rank",
          style:
            "min-width: 40px;max-width: 40px;width: 40px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "association_abbr",
          label: "Club",
          align: "left",
          field: "association_abbr",
          style:
            "min-width: 200px;max-width: 200px;width: 200px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "medals",
          label: "Medals",
          align: "left",
          field: "medals",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "1",
          label: "1st",
          align: "left",
          field: "1",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "2",
          label: "2nd",
          align: "left",
          field: "2",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "3",
          label: "3rd",
          align: "left",
          field: "3",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "4",
          label: "4th",
          align: "left",
          field: "4",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "5",
          label: "5th",
          align: "left",
          field: "5",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
        {
          name: "6",
          label: "6th",
          align: "left",
          field: "6",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
          sortable: true,
        },
      ],
    }),
    watch: {
      selectedEvent: function () {
        if (this.selectedEvent) {
          this.$store.dispatch("liveResults/eventBrackets", {
            events_id: this.selectedEvent.id,
          });
        }
      },
      brackets: function () {
        this.initBrackets();
      },
    },
    mounted() {
      this.$store.dispatch("liveResults/overallPoints", {
        competitions_id: this.$route.params.competitions_id,
      });
      this.$store.dispatch("liveResults/overallMedals", {
        competitions_id: this.$route.params.competitions_id,
      });

      this.$store.dispatch(
        "events/loadForCompetition",
        this.$route.params.competitions_id
      );
    },
    methods: {
      initBrackets() {
        if (this.brackets.length > 0) {
          this.isTeamEvent = JSON.parse(this.brackets[0].playerLabels).length > 1;
        }
      },
      handleDoubleClickEvents(row) {
        this.selectedEvent = row;
      },
      ordinal_suffix_of(i) {
        if (isNaN(i)) return i;
        var j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      },

      // Overall Points
      handleDoubleClickOverallPoints(row) {
        console.log(row);
      },
    },
  };
</script>

<style lang="scss">
  .container {
    width: 90%;
    min-width: 18em;
    margin: 20px auto;

    h1,
    h2 {
      text-align: center;
    }

    h1 {
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 0.5em;
    }

    h2 {
      font-size: 1.4rem;
      font-weight: 600;
      margin-bottom: 2em;
    }

    //
    // TOURNAMENT BRACKET
    // ---------------------------
    .tournament-bracket {
      display: flex;
      flex-direction: column;

      @media (min-width: $breakpoint-sm) {
        flex-direction: row;
      }
    }

    .tournament-bracket__round {
      display: block;
      margin-left: -3px;
      flex: 1;
    }

    .tournament-bracket__round-title {
      color: #9e9e9e;
      font-size: 0.95rem;
      font-weight: 400;
      text-align: center;
      margin-bottom: 0.5em;
    }

    .tournament-bracket__list {
      display: flex;
      flex-direction: column;
      flex-flow: row wrap;
      justify-content: center;
      border-bottom: 1px dashed #e5e5e5;
      padding-bottom: 2em;
      margin-bottom: 2em;
      padding-inline-start: 0px;
      transition: padding 0.2s ease-in-out, margin 0.2s ease-in-out;

      @media (max-width: $breakpoint-xs) {
        padding-bottom: 1em;
        margin-bottom: 1em;
      }

      @media (min-width: $breakpoint-sm) {
        margin-bottom: 0;
        padding-bottom: 0;
        border-right: 1px dashed #e5e5e5;
        border-bottom: 0;
      }

      .tournament-bracket__round:last-child & {
        border: 0;
      }
    }

    .tournament-bracket__item {
      display: flex;
      flex: 0 1 auto;
      justify-content: center;
      flex-direction: column;
      align-items: flex-start;
      position: relative;
      padding: 2% 0;
      width: 48%;
      transition: padding 0.2s linear;

      &:nth-child(odd) {
        margin-right: 2%;
      }

      &:nth-child(even) {
        margin-left: 2%;
      }

      &::after {
        transition: width 0.2s linear;
      }

      @media (max-width: $breakpoint-xs) {
        width: 100%;

        &:nth-child(odd),
        &:nth-child(even) {
          margin-left: 0;
          margin-right: 0;
        }
      }

      @media (min-width: $breakpoint-sm) {
        padding: 0.5em 1em;
        // flex-grow: 2;
        width: 100%;

        &:nth-child(odd),
        &:nth-child(even) {
          margin: 0;
        }

        &::after {
          position: absolute;
          right: 0;
          content: "";
          display: block;
          width: 1em;
          height: 45%;
        }

        &:nth-child(odd)::after {
          & {
            border-top-right-radius: 0.6em;
          }
        }

        &:nth-child(even)::after {
          & {
            border-bottom-right-radius: 0.6em;
          }
        }
        .tournament-bracket__round:first-child & {
          padding-left: 0;
        }
        .tournament-bracket__round:last-child & {
          padding-right: 0;

          &::after {
            display: none;
          }
        }
      }

      @media (min-width: $breakpoint-lg) {
        padding: 0.5em 1.5em;

        &::after {
          width: 1.5em;
        }
      }
    }

    .tournament-bracket__match {
      display: flex;
      width: 100%;
      background-color: #ffffff;
      padding: 1em;
      border: 1px solid transparent;
      border-radius: 0.1em;
      box-shadow: 0 2px 0 0 #e5e5e5;
      outline: none;
      cursor: pointer;
      transition: padding 0.2s ease-in-out, border 0.2s linear;

      &:focus {
        border-color: #2196f3;
      }

      &::before,
      &::after {
        transition: all 0.2s linear;
      }

      @media (max-width: $breakpoint-xs) {
        padding: 0.75em 0.5em;
      }

      @media (min-width: $breakpoint-sm) {
        &::before,
        &::after {
          position: absolute;
          left: 0;
          z-index: 1;
          content: "";
          display: block;
          width: 1em;
          height: 10%;
        }

        &::before {
        }

        &::after {
        }
      }

      @media (min-width: $breakpoint-lg) {
        &::before,
        &::after {
          width: 1.5em;
        }

        &::before {
          transform: translate(0, 1px);
        }

        &::after {
          transform: translate(0, -1px);
        }
      }
    }

    .tournament-bracket__round:last-child .tournament-bracket__match {
      &::before,
      &::after {
        border-left: 0;
      }

      &::before {
        border-bottom-left-radius: 0;
      }

      &::after {
        display: none;
      }
    }

    .tournament-bracket__round:first-child .tournament-bracket__match {
      &::before,
      &::after {
        display: none;
      }
    }

    .tournament-bracket__table {
      width: 100%;

      .clubCap {
        width: 40px;
      }
    }

    .tournament-bracket__caption {
      font-size: 0.8rem;
      color: #bdbdbd;
      font-weight: 300;
      padding-bottom: 0.75em;
    }

    .singlePassthrough::after {
      border-radius: 0 !important;
      border-right: 0;
      // border-top: 0 !important;
    }

    .notBracket::after {
      border-radius: 0 !important;
      border-right: 0 !important;
      border-top: 0 !important;
      border-bottom: 0 !important;
    }

    .notBracket {
      .tournament-bracket__match {
        &::before {
          border-radius: 0 !important;
          border-left: 0 !important;
          border-bottom: 0 !important;
        }

        &::after {
          border-radius: 0 !important;
          border-left: 0 !important;
          border-top: 0 !important;
        }
      }
    }

    .bracketStart {
      .tournament-bracket__match {
        &::before {
          border-radius: 0 !important;
          border-left: 0 !important;
          border-bottom: 0 !important;
        }

        &::after {
          border-radius: 0 !important;
          border-left: 0 !important;
          border-top: 0 !important;
        }
      }
    }

    .finalBracket::after {
      border-radius: 0 !important;
      border: 0 !important;
    }
    .noMoreEvents {
      border-right: 0;
    }
  }
</style>


